import { i18n } from '@lingui/core';
import { detect, fromNavigator, fromStorage } from '@lingui/detect-locale';
import { I18nProvider as LinguiI18nProvider, useLingui } from '@lingui/react';
import { useEffect } from 'react';
import { CONFIG } from 'src/config';
import { defaultLocale, dynamicActivate } from 'src/i18n';

export function I18nProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const lang = detect(
      fromStorage('i18nLocale'),
      fromNavigator(),
      defaultLocale
    ) as string;
    void dynamicActivate(CONFIG.EnableLocalization ? lang : defaultLocale);
  }, []);

  return (
    <LinguiI18nProvider i18n={i18n}>
      <Inner>{children}</Inner>
    </LinguiI18nProvider>
  );
}

function Inner({ children }: { children: React.ReactNode }) {
  const lingui = useLingui();

  // Update html lang attribute when locale changes
  useEffect(() => {
    document.documentElement.lang = lingui.i18n.locale || defaultLocale;
  }, [lingui.i18n.locale]);

  return children;
}
